const config = {
    development: {
        apiUrl: 'https://resturant.local:8890/api/v1'
    },
    production: {
        apiUrl: process.env.REACT_APP_API_URL || 'https://tnour-resturant.khabeer-tech.com/api/v1'
    }
};

const environment = process.env.NODE_ENV || 'development';
export const apiConfig = config[environment];
